import React from 'react';

const industries = [
  {
    title: "Healthcare & Life Sciences",
    description:
      "Innovative IT solutions for hospitals, labs, and research institutions. From patient portals to health data analytics, we deliver efficiency and care.",
    image: "/assets/img/healthcare.jpg",
  },
  {
    title: "Finance & Banking",
    description:
      "Custom fintech solutions, secure transactions, and digital banking transformation to help financial institutions scale securely and quickly.",
    image: "/assets/img/finance.jpg",
  },
  {
    title: "Retail & eCommerce",
    description:
      "Ecommerce platforms, POS integrations, inventory automation, and customer insights to boost your retail performance.",
    image: "/assets/img/retail.jpg",
  },
  {
    title: "Education & eLearning",
    description:
      "LMS platforms, virtual classrooms, and mobile learning apps tailored for universities, schools, and corporate training.",
    image: "/assets/img/education.jpg",
  },
  {
    title: "Real Estate & Construction",
    description:
      "CRM, 3D property tours, and construction project tracking to streamline operations and improve client engagement.",
    image: "/assets/img/realestate.jpg",
  },
  {
    title: "Travel & Hospitality",
    description:
      "Booking engines, virtual concierge apps, and guest experience management tools to elevate hospitality services.",
    image: "/assets/img/travel.jpg",
  },
];

const Industries = () => {
  return (
    
    <div className="industries-page py-5">
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: `url('/assets/img/bg/breadcumb-bg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          marginTop:"-45px"
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Industries</h1>
            <ul className="breadcumb-menu">
              <li><a href="/">Home</a></li>
              <li>Industries</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold">Industries We Serve</h2>
          <p className="text-muted">
            Transforming businesses across diverse sectors with powerful, scalable technology.
          </p>
        </div>

        <div className="row">
          {industries.map((industry, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div className="card h-100 shadow-sm border-0">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="card-img-top"
                  style={{ height: '200px', objectFit: 'cover' }}
                />
                <div className="card-body">
                  <h5 className="card-title">{industry.title}</h5>
                  <p className="card-text text-muted">{industry.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Industries;
